import React from 'react';
import PropTypes from 'prop-types';

function Badge({ children, customBg, type })
{
    if (type === 'secondary')
    {
        return (
            <span className={`tw-px-4 tw-py-2 tw-text-white tw-rounded ${children === 'Pending' && 'tw-bg-[#575D59]'} ${children === 'Cancelled' && 'tw-bg-danger-default'} ${children === 'Booked' && 'tw-bg-success-default'}`}> {children} </span>
        );
    }

    return (
        <span className={`tw-px-2 tw-py-1 tw-text-white tw-rounded ${!customBg ? 'tw-bg-primary-default ' : customBg}`}> {children} </span>
    );
}

Badge.defaultProps = {
    type: 'primary',
};

Badge.propTypes = {
    children: PropTypes.node,
    customBg: PropTypes.string,
    type: PropTypes.string,
};

export default Badge;
